/**
 * Markdown Library - SQL Highlighter
 *
 * Delega para o formatador SQL compartilhado (única implementação).
 */

import { formatSQLWithHighlight } from '@/shared/lib/sqlFormatter';

/**
 * SQL highlighter component with token styling.
 */
export function SqlHighlightedCode({ sql }: { sql: string }) {
    return (
        <span
            className="text-white"
            dangerouslySetInnerHTML={{ __html: formatSQLWithHighlight(sql) }}
        />
    );
}
